import { useEffect } from 'react';

/**
 * Hook para lidar com erros de carregamento de chunks
 * Detecta erros de "Loading chunk X failed" e força reload da página
 */
export function useChunkErrorHandler() {
  useEffect(() => {
    const handleChunkError = (event: ErrorEvent) => {
      const error = event.error;
      const message = event.message || '';
      
      // Detectar erros de chunk loading
      const isChunkError = 
        message.includes('Loading chunk') ||
        message.includes('error loading dynamically imported module') ||
        (error && error.name === 'ChunkLoadError') ||
        (error && error.message && error.message.includes('Loading chunk'));

      if (isChunkError) {
        console.warn('Chunk loading error detected, reloading page:', { error, message });
        
        // Mostrar notificação antes de recarregar
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification('Atualizando aplicação...', {
            body: 'Detectamos uma atualização. Recarregando automaticamente.',
            icon: '/favicon.ico'
          });
        }

        // Aguardar um pouco antes de recarregar para dar tempo da notificação aparecer
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error = event.reason;
      
      if (error && typeof error === 'object') {
        const message = error.message || '';
        const isChunkError = 
          message.includes('Loading chunk') ||
          message.includes('error loading dynamically imported module') ||
          error.name === 'ChunkLoadError';

        if (isChunkError) {
          console.warn('Chunk loading promise rejection detected, reloading page:', error);
          event.preventDefault(); // Previne o erro de aparecer no console
          
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
    };

    // Adicionar listeners
    window.addEventListener('error', handleChunkError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup
    return () => {
      window.removeEventListener('error', handleChunkError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);
}

export default useChunkErrorHandler;

